import { Dispatch, SetStateAction } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { PricebookPeriodOverviewRow } from "../../../types/price-book.type";
import Skeleton from "../../ReprintAuth/Skeleton";
import CataloguePagination from "../shared/Pagination";
import { catalogueRowHeight } from "../shared/constants";
import PricePeriodRow from "./Row";

const COLUMNS: { label: string; width?: string }[] = [
  { label: "สมุดราคา", width: "16%" },
  { label: "สินค้า" },
  { label: "ช่วงราคา", width: "15%" },
  { label: "ราคารวม VAT", width: "9%" },
  { label: "ราคาก่อน VAT", width: "9%" },
  { label: "ราคาถัดไป (รวม / ก่อน VAT)", width: "13%" },
  { label: "สถานะ", width: "8%" },
];
const ACTION_COLUMN = { label: "ต่อช่วง", width: "6%" };
/** A name over its code is the tallest cell. */
const ROW_CONTENT_HEIGHT = 40;
const ROW_HEIGHT = catalogueRowHeight(ROW_CONTENT_HEIGHT);

interface PricePeriodTableProps {
  rows: PricebookPeriodOverviewRow[];
  loading: boolean;
  totalCount: number;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  limit: number;
  setLimit: Dispatch<SetStateAction<number>>;
  canExtend: boolean;
  onOpen: (row: PricebookPeriodOverviewRow) => void;
  onExtend: (row: PricebookPeriodOverviewRow) => void;
}

/** Every book's periods with the price each line goes to once its period ends. */
export default function PricePeriodTable({
  rows,
  loading,
  totalCount,
  page,
  setPage,
  limit,
  setLimit,
  canExtend,
  onOpen,
  onExtend,
}: PricePeriodTableProps) {
  const columns = canExtend ? [...COLUMNS, ACTION_COLUMN] : COLUMNS;

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead sx={{ bgcolor: (theme) => theme.palette.background.default }}>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.label} align="center" sx={{ width: column.width }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <Skeleton columns={columns.length} rows={limit} rowHeight={ROW_HEIGHT} />
            )}
            {!loading && rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={columns.length} align="center" sx={{ py: 5 }}>
                  <Typography color="text.secondary" fontWeight={500}>
                    ไม่พบช่วงราคา
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {!loading &&
              rows.map((row, index) => (
                <PricePeriodRow
                  key={row.uuid}
                  row={row}
                  striped={index % 2 === 1}
                  canExtend={canExtend}
                  onOpen={onOpen}
                  onExtend={onExtend}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CataloguePagination
        totalCount={totalCount}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
      />
    </Paper>
  );
}
